Object.defineProperty(exports, "__esModule", {
  value: true
});

var topic_1 = require("./models/topic/topic");

Object.defineProperty(exports, "Topic", {
  enumerable: true,
  get: function get() {
    return topic_1.Topic;
  }
});

var topic_media_1 = require("./models/topic/topic-media");

Object.defineProperty(exports, "TopicMedia", {
  enumerable: true,
  get: function get() {
    return topic_media_1.TopicMedia;
  }
});

var topic_section_1 = require("./models/topic-section/topic-section");

Object.defineProperty(exports, "TopicSection", {
  enumerable: true,
  get: function get() {
    return topic_section_1.TopicSection;
  }
});

var get_topic_info_1 = require("./lib/get-topic-info");

Object.defineProperty(exports, "getTopicInfo", {
  enumerable: true,
  get: function get() {
    return get_topic_info_1.getTopicInfo;
  }
});

var get_topic_options_1 = require("./lib/get-topic-options");

Object.defineProperty(exports, "topicOptionsEnglish", {
  enumerable: true,
  get: function get() {
    return get_topic_options_1.topicOptionsEnglish;
  }
});
Object.defineProperty(exports, "topicOptionsDutch", {
  enumerable: true,
  get: function get() {
    return get_topic_options_1.topicOptionsDutch;
  }
});

var get_topic_options_2 = require("./lib/get-topic-options");

Object.defineProperty(exports, "getEmptyTopicOptions", {
  enumerable: true,
  get: function get() {
    return get_topic_options_2.getEmptyTopicOptions;
  }
});
Object.defineProperty(exports, "getTopicOptions", {
  enumerable: true,
  get: function get() {
    return get_topic_options_2.getTopicOptions;
  }
});

var topic_model_config_1 = require("./config/topic-model-config");

Object.defineProperty(exports, "topicModelConfig", {
  enumerable: true,
  get: function get() {
    return topic_model_config_1.topicModelConfig;
  }
});